import { IQueryStrings } from '@lifk/types'

export const QueryStrings: IQueryStrings = {
  contentType: 'contentType',
  remedy: 'remedy',
  effect: 'effect',
  key: 'item',
  mappedRemedy: 'clickedRemedy',
  dataLayer: 'dataLayer',
  tab: 'tab'
}
